import React, { useCallback, useState } from 'react';
const GridItem = ({ id, layout, metrics, cols, minW = 1, minH = 1, onDragEnd, onResizeEnd, children }) => {
    const [dragOffset, setDragOffset] = useState(null);
    const [resizeDelta, setResizeDelta] = useState(null);

    const { colWidth, rowHeight, marginX, marginY } = metrics;
    const cellW = colWidth + marginX;
    const cellH = rowHeight + marginY;

    const baseLeft = layout.x * cellW;
    const baseTop = layout.y * cellH;
    const baseWidth = layout.w * colWidth + (layout.w - 1) * marginX;
    const baseHeight = layout.h * rowHeight + (layout.h - 1) * marginY;

    const handleMouseDown = useCallback((e) => {
        if (e.target.closest('.widget-card__remove') || e.target.closest('.widget-card__action')) return;
        const isResize = e.target.closest('.widget-resize-handle');
        const isDrag = e.target.closest('.widget-drag-handle');
        if (!isResize && !isDrag) return;

        e.preventDefault();
        const mode = isResize ? 'resize' : 'move';
        const startX = e.clientX;
        const startY = e.clientY;

        const handleMouseMove = (ev) => {
            const dx = ev.clientX - startX;
            const dy = ev.clientY - startY;
            if (mode === 'move') setDragOffset({ dx, dy });
            else setResizeDelta({ dw: dx, dh: dy });
        };

        const handleMouseUp = (ev) => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
            const dx = ev.clientX - startX;
            const dy = ev.clientY - startY;

            if (mode === 'move') {
                const newX = Math.round((baseLeft + dx) / cellW);
                const newY = Math.max(0, Math.round((baseTop + dy) / cellH));
                const clampedX = Math.max(0, Math.min(cols - layout.w, newX));
                setDragOffset(null);
                onDragEnd(id, { x: clampedX, y: newY });
            } else {
                const newWidthPx = baseWidth + dx;
                const newHeightPx = baseHeight + dy;
                const rawW = Math.round((newWidthPx + marginX) / cellW);
                const rawH = Math.round((newHeightPx + marginY) / cellH);
                const newW = Math.max(minW, Math.min(cols - layout.x, rawW));
                const newH = Math.max(minH, rawH);
                setResizeDelta(null);
                onResizeEnd(id, { w: newW, h: newH });
            }
        };

        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', handleMouseUp);
    }, [baseLeft, baseTop, baseWidth, baseHeight, cellW, cellH, marginX, marginY, cols, layout.w, layout.x, id, onDragEnd, onResizeEnd, minW, minH]);

    const isActive = Boolean(dragOffset || resizeDelta);
    const style = {
        position: 'absolute',
        left: baseLeft + (dragOffset?.dx || 0),
        top: Math.max(0, baseTop + (dragOffset?.dy || 0)),
        width: baseWidth + (resizeDelta?.dw || 0),
        height: baseHeight + (resizeDelta?.dh || 0),
        transition: isActive ? 'none' : 'left 0.15s ease, top 0.15s ease, width 0.15s ease, height 0.15s ease',
        zIndex: isActive ? 10 : 1,
    };

    return (
        <div
            className={`grid-item${isActive ? ' grid-item--active' : ''}`}
            style={style}
            onMouseDown={handleMouseDown}
        >
            {children}
            <div className="widget-resize-handle" />
        </div>
    );
};

export default GridItem;
